<template>
  <div class="modern-ecommerce-dashboard min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
    <!-- Dashboard Header -->
    <div class="dashboard-header mb-8">
      <div class="flex items-center justify-between mb-6">
        <div>
          <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            דשבורד מסחר אלקטרוני
          </h1>
          <p class="text-gray-600 dark:text-gray-400">ברוכים הבאים למערכת המסחר האלקטרוני</p>
        </div>
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-lg">
            <i class="material-symbols-outlined text-white text-xl" style="color: white !important; font-size: 1.25rem;">storefront</i>
          </div>
        </div>
      </div>
    </div>

    <!-- Modern Stats Grid -->
    <div class="stats-grid mb-8">
      <!-- Total Sales Card -->
      <div class="stat-card floating-card">
        <div class="stat-header">
          <div class="stat-icon sales">
            <div class="icon-background">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
            </div>
          </div>
          <button class="action-btn modern-btn">
            <i class="material-symbols-outlined text-sm">more_vert</i>
          </button>
        </div>
        <div class="stat-content">
          <h3 class="stat-number">₪847,562</h3>
          <p class="stat-label">סה"כ מכירות</p>
          <div class="stat-change positive">
            <div class="change-badge">
              <i class="material-symbols-outlined text-xs">trending_up</i>
              <span>+23%</span>
            </div>
            <span class="change-text">מהחודש שעבר</span>
          </div>
        </div>
      </div>

      <!-- Total Orders Card -->
      <div class="stat-card floating-card">
        <div class="stat-header">
          <div class="stat-icon orders">
            <div class="icon-background">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
          </div>
          <button class="action-btn modern-btn">
            <i class="material-symbols-outlined text-sm">more_vert</i>
          </button>
        </div>
        <div class="stat-content">
          <h3 class="stat-number">3,247</h3>
          <p class="stat-label">הזמנות חדשות</p>
          <div class="stat-change positive">
            <div class="change-badge">
              <i class="material-symbols-outlined text-xs">trending_up</i>
              <span>+15%</span>
            </div>
            <span class="change-text">מהשבוע שעבר</span>
          </div>
        </div>
      </div>

      <!-- Total Customers Card -->
      <div class="stat-card floating-card">
        <div class="stat-header">
          <div class="stat-icon customers">
            <div class="icon-background">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
          </div>
          <button class="action-btn modern-btn">
            <i class="material-symbols-outlined text-sm">more_vert</i>
          </button>
        </div>
        <div class="stat-content">
          <h3 class="stat-number">12,456</h3>
          <p class="stat-label">לקוחות פעילים</p>
          <div class="stat-change positive">
            <div class="change-badge">
              <i class="material-symbols-outlined text-xs">trending_up</i>
              <span>+8%</span>
            </div>
            <span class="change-text">מהחודש שעבר</span>
          </div>
        </div>
      </div>

      <!-- Total Revenue Card -->
      <div class="stat-card floating-card">
        <div class="stat-header">
          <div class="stat-icon revenue">
            <div class="icon-background">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
            </div>
          </div>
          <button class="action-btn modern-btn">
            <i class="material-symbols-outlined text-sm">more_vert</i>
          </button>
        </div>
        <div class="stat-content">
          <h3 class="stat-number">₪234,890</h3>
          <p class="stat-label">הכנסות חודשיות</p>
          <div class="stat-change positive">
            <div class="change-badge">
              <i class="material-symbols-outlined text-xs">trending_up</i>
              <span>+32%</span>
            </div>
            <span class="change-text">מהחודש שעבר</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modern Quick Actions Section -->
    <div class="quick-actions-section mb-8">
      <h2 class="section-title mb-6">פעולות מהירות</h2>
      <div class="actions-grid">
        <button class="action-card floating-card modern-action">
          <div class="action-icon-wrapper">
            <div class="action-icon new-product">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </div>
          </div>
          <div class="action-content">
            <h3 class="action-title">הוסף מוצר חדש</h3>
            <p class="action-description">הוסף מוצר חדש לחנות</p>
          </div>
          <div class="action-arrow">
            <i class="material-symbols-outlined">arrow_back_ios</i>
          </div>
        </button>

        <button class="action-card floating-card modern-action">
          <div class="action-icon-wrapper">
            <div class="action-icon order">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
              </svg>
            </div>
          </div>
          <div class="action-content">
            <h3 class="action-title">עבד הזמנה</h3>
            <p class="action-description">עבד והשלם הזמנות</p>
          </div>
          <div class="action-arrow">
            <i class="material-symbols-outlined">arrow_back_ios</i>
          </div>
        </button>

        <button class="action-card floating-card modern-action">
          <div class="action-icon-wrapper">
            <div class="action-icon inventory">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
          </div>
          <div class="action-content">
            <h3 class="action-title">נהל מלאי</h3>
            <p class="action-description">עדכן ועקוב אחר המלאי</p>
          </div>
          <div class="action-arrow">
            <i class="material-symbols-outlined">arrow_back_ios</i>
          </div>
        </button>

        <button class="action-card floating-card modern-action">
          <div class="action-icon-wrapper">
            <div class="action-icon analytics">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
          </div>
          <div class="action-content">
            <h3 class="action-title">צפה בדוחות</h3>
            <p class="action-description">נתח את נתוני המכירות</p>
          </div>
          <div class="action-arrow">
            <i class="material-symbols-outlined">arrow_back_ios</i>
          </div>
        </button>
      </div>
    </div>

    <!-- Charts Section -->
    <div class="charts-section mb-8">
      <h2 class="section-title mb-6">ניתוחים ודוחות</h2>
      <div class="charts-grid">
        <div class="chart-wrapper floating-card">
          <TotalSalesChart />
        </div>
        <div class="chart-wrapper floating-card">
          <SalesByLocations />
        </div>
      </div>
    </div>

    <!-- Products and Orders Section -->
    <div class="products-orders-section mb-8">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div class="floating-card">
          <TopSellingProducts />
        </div>
        <div class="floating-card">
          <WelcomeDashboard />
        </div>
      </div>
    </div>

    <!-- Recent Activity Section -->
    <div class="activity-section">
      <h2 class="section-title mb-6">פעילות אחרונה</h2>
      <div class="activity-wrapper floating-card">
        <RecentOrders />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import WelcomeDashboard from "@/components/Dashboard/Ecommerce/WelcomeDashboard.vue";
import TotalSalesChart from "@/components/Dashboard/Ecommerce/TotalSalesChart.vue";
import SalesByLocations from "@/components/Dashboard/Ecommerce/SalesByLocations.vue";
import TopSellingProducts from "@/components/Dashboard/Ecommerce/TopSellingProducts.vue";
import RecentOrders from "@/components/Dashboard/Ecommerce/RecentOrders.vue";

export default defineComponent({
  name: "EcommercePage",
  components: {
    WelcomeDashboard,
    TotalSalesChart,
    SalesByLocations,
    TopSellingProducts,
    RecentOrders,
  },
});
</script>

<style scoped>
/* Modern Ecommerce Dashboard - Floating Cards Design */
.modern-ecommerce-dashboard {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  direction: rtl;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

/* Dashboard Header */
.dashboard-header {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 1rem;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 1rem;
  padding: 1.25rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.dashboard-header h1 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.dashboard-header p {
  font-size: 0.875rem;
}

/* Section Titles */
.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

/* Floating Cards Base */
.floating-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1.25rem;
  box-shadow: 
    0 10px 25px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.floating-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #10b981, #3b82f6, #8b5cf6);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.floating-card:hover::before {
  opacity: 1;
}

.floating-card:hover {
  transform: translateY(-8px);
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.15),
    0 20px 25px -5px rgba(0, 0, 0, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}

/* Stat Cards */
.stat-card {
  padding: 1.25rem;
}

/* Stat Header */
.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.icon-background {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.stat-icon.sales {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 8px 25px rgba(16, 185, 129, 0.3);
}

.stat-icon.orders {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
}

.stat-icon.customers {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.3);
}

.stat-icon.revenue {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.3);
}

.stat-icon::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transform: rotate(45deg);
  transition: transform 0.6s ease;
}

.floating-card:hover .stat-icon::before {
  transform: rotate(45deg) translate(100%, 100%);
}

.modern-btn {
  width: 32px;
  height: 32px;
  border-radius: 0.625rem;
  border: none;
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
}

.modern-btn:hover {
  background: rgba(107, 114, 128, 0.2);
  color: #374151;
  transform: scale(1.05);
}

/* Stat Content */
.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 1.75rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.25rem;
  line-height: 1;
  background: linear-gradient(135deg, #111827 0%, #374151 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.stat-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-change {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.change-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  width: fit-content;
}

.stat-change.positive .change-badge {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.15) 100%);
  color: #065f46;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.stat-change.negative .change-badge {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.15) 100%);
  color: #991b1b;
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.change-text {
  font-size: 0.625rem;
  color: #9ca3af;
  font-weight: 500;
}

/* Modern Quick Actions */
.actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
}

.modern-action {
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  border: none;
  text-align: right;
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
}

.modern-action:hover {
  transform: translateY(-4px);
}

.action-icon-wrapper {
  position: relative;
}

.action-icon {
  width: 44px;
  height: 44px;
  border-radius: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.action-icon.new-product {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  box-shadow: 0 8px 25px rgba(16, 185, 129, 0.3);
}

.action-icon.order {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
}

.action-icon.inventory {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.3);
}

.action-icon.analytics {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.3);
}

.action-icon::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: rotate(45deg);
  transition: transform 0.6s ease;
}

.modern-action:hover .action-icon::before {
  transform: rotate(45deg) translate(100%, 100%);
}

.modern-action:hover .action-icon {
  transform: scale(1.05);
}

.action-content {
  flex: 1;
}

.action-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.125rem;
}

.action-description {
  font-size: 0.75rem;
  color: #6b7280;
  line-height: 1.3;
}

.action-arrow {
  color: #9ca3af !important;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.modern-action:hover .action-arrow {
  transform: translateX(-4px);
  color: #6b7280 !important;
}

/* Charts and Activity Sections */
.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
}

.chart-wrapper,
.activity-wrapper {
  padding: 0;
  overflow: hidden;
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .modern-ecommerce-dashboard {
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  }

  .floating-card {
    background: rgba(30, 41, 59, 0.8);
    border-color: rgba(148, 163, 184, 0.1);
  }

  .floating-card:hover {
    border-color: rgba(148, 163, 184, 0.2);
  }

  .dashboard-header {
    background: rgba(30, 41, 59, 0.7);
    border-color: rgba(148, 163, 184, 0.1);
  }

  .section-title {
    color: #f8fafc;
  }

  .stat-number {
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .action-title {
    color: #f8fafc;
  }

  .modern-btn {
    background: rgba(148, 163, 184, 0.1);
    color: #94a3b8;
  }

  .modern-btn:hover {
    background: rgba(148, 163, 184, 0.2);
    color: #e2e8f0;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-ecommerce-dashboard {
    padding: 0.75rem;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .actions-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .charts-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .stat-card,
  .modern-action {
    padding: 1rem;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
  
  .section-title {
    font-size: 1.125rem;
  }

  .dashboard-header {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .dashboard-header h1 {
    font-size: 1.75rem;
  }
}

@media (max-width: 480px) {
  .dashboard-header h1 {
    font-size: 1.5rem;
  }
  
  .stats-grid,
  .actions-grid {
    gap: 0.5rem;
  }
  
  .stat-card,
  .modern-action {
    padding: 0.875rem;
  }
  
  .modern-action {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }
  
  .action-arrow {
    transform: rotate(90deg);
  }
  
  .modern-action:hover .action-arrow {
    transform: rotate(90deg) translateY(-4px);
  }

  .stat-icon,
  .action-icon {
    width: 40px;
    height: 40px;
  }

  .stat-number {
    font-size: 1.375rem;
  }

  .section-title {
    font-size: 1rem;
  }
}

/* Animation for cards */
.floating-card {
  animation: fadeInScale 0.6s cubic-bezier(0.4, 0.0, 0.2, 1);
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.stat-card:nth-child(1) { animation-delay: 0.1s; }
.stat-card:nth-child(2) { animation-delay: 0.2s; }
.stat-card:nth-child(3) { animation-delay: 0.3s; }
.stat-card:nth-child(4) { animation-delay: 0.4s; }

.modern-action:nth-child(1) { animation-delay: 0.1s; }
.modern-action:nth-child(2) { animation-delay: 0.2s; }
.modern-action:nth-child(3) { animation-delay: 0.3s; }
.modern-action:nth-child(4) { animation-delay: 0.4s; }
</style>
